<app-loader [ShowLoader]="globalService.showLoader"></app-loader>
<router-outlet></router-outlet>
